import type { GeoJsonObject } from 'geojson';
import L from 'leaflet';
import { ArrowPolyLine } from '../Layers/ArrowPolyLine';
import { type ExtentLayerOptions } from '../Layers/Layers.types';

const defaultOptions: ExtentLayerOptions = {
    style: function (feature) {
        const isLine = feature.geometry.type.includes('Line');
        return {
            fillColor: 'var(--cc-map-affected-area-fill)',
            fillOpacity: 0.15,
            color: 'var(--cc-map-affected-area-stroke)',
            lineCap: 'square',
            opacity: 1,
            weight: isLine ? 5 : 2,
            interactive: false,
        };
    },
    pointToLayer: function (geojson, latLng) {
        return L.circleMarker(latLng, {
            radius: 7,
            fillColor: 'var(--cc-map-affected-area-fill)',
            fillOpacity: 0.15,
            color: 'var(--cc-map-affected-area-stroke)',
            weight: 2,
            interactive: false,
        });
    },
};

export const affectedArea = function (geoJson: GeoJsonObject, options?: ExtentLayerOptions): L.GeoJSON | ArrowPolyLine {
    const mergedOptions = { ...defaultOptions, ...options };
    if (geoJson?.type.includes('Line')) {
        return new ArrowPolyLine(geoJson, mergedOptions);
    }
    return L.geoJSON(geoJson, mergedOptions);
};
